import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllCategoriaResponse } from '../../responses/produto/get-all-categoria.response';
import { GetCategoriaResponse } from '../../responses/produto/get-categoria.response';
import { CategoriaRequest } from '../../requests/produto/categoria.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class CategoriaService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}categoria`;

    /**
     * Obtém a lista de Categorias.
     */
    public getAll(nome: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllCategoriaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<GetAllCategoriaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma categoria.
     */
    public delete(idCategoria: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idCategoria}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas categorias.
     */
    public deleteBulk(idsCategoria: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsCategoria }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma categoria por ID.
     */
    public getById(idCategoria: number): Observable<GetCategoriaResponse> {
        const url = `${this.apiUrl}/${idCategoria}`;

        return this.httpClient
            .get<GetCategoriaResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém a família completa (a partir da raiz) de uma categoria.
     */
    public getByIdComFamilia(idCategoria: number): Observable<GetCategoriaResponse> {
        const url = `${this.apiUrl}/getPorIdComFamilia/${idCategoria}`;

        return this.httpClient
            .get<GetCategoriaResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova categoria.
     */
    public create(request: CategoriaRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma categoria existente.
     */
    public update(idCategoria: number, request: CategoriaRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idCategoria}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
